import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { createUIError, IIndicator, isErrorIndicator, isProgressIndicator, IUIError } from "@gtmhub/error-handling";
import { localize } from "@gtmhub/localization";

@Component({
  selector: "gh-indicator",
  templateUrl: "./gh-indicator.component.html",
})
export class GhIndicatorComponent implements OnChanges {
  @Input()
  public ghValue: IIndicator;
  @Input()
  public ghMessage: string;
  @Output()
  public onReset = new EventEmitter<void>();

  get message(): string {
    if (this.longLastingRequest) {
      return localize("sluggish_give_secs");
    }
    if (this.timingOut) {
      return localize("request_too_long");
    }
    return this.ghMessage;
  }

  public progress: boolean;
  public uiError: IUIError;

  private sluggishTimeout: ReturnType<typeof setTimeout>;
  private longLastingRequest: boolean;
  private timingOut: boolean;

  public ngOnChanges(changes: SimpleChanges): void {
    const ghValue: IIndicator = changes.ghValue?.currentValue;
    if (!ghValue) {
      this.progress = null;
      this.uiError = null;
      return;
    }
    this.cancelSluggishTimeout();
    if (isErrorIndicator(ghValue)) {
      this.uiError = createUIError(ghValue.error);
    }
    if (isProgressIndicator(ghValue) && ghValue.progress) {
      this.setSluggishTimeout();
      this.progress = ghValue.progress;
    }
  }

  public reset(): void {
    this.onReset.emit();
  }

  private setSluggishTimeout(): void {
    this.sluggishTimeout = setTimeout(() => {
      this.longLastingRequest = true;
      this.sluggishTimeout = setTimeout(() => {
        this.longLastingRequest = false;
        this.timingOut = true;
        this.sluggishTimeout = null;
      }, 75000);
    }, 5000);
  }

  private cancelSluggishTimeout(): void {
    if (this.sluggishTimeout) {
      clearTimeout(this.sluggishTimeout);
      this.sluggishTimeout = null;
    }
    this.longLastingRequest = false;
    this.timingOut = false;
  }
}
